// Sort roadmap items so the most-immediate timeframe comes first.
// Matches /app/backend/core/utils.py::_roadmap_timeframe_order so the
// ordering is identical wherever we render the roadmap (dashboard,
// web report, PDF).
function timeframeOrder(item) {
  const cg = item?.closes_gap;
  if (Number.isInteger(cg) && cg > 0) return cg - 1000; // gap-aligned: keep gap order
  const tf = (item?.timeframe || "").trim().toLowerCase();
  if (!tf) return 9999;
  const m = tf.match(/(\d+(?:\.\d+)?)/);
  if (!m) return 9998;
  const n = parseFloat(m[1]);
  if (tf.includes("week")) return n * 0.25;
  if (tf.includes("year")) return n * 12;
  return n; // default to months
}

export function sortRoadmap(roadmap) {
  if (!Array.isArray(roadmap)) return [];
  // Stable copy + sort
  return [...roadmap].sort((a, b) => timeframeOrder(a) - timeframeOrder(b));
}
